import { render, staticRenderFns } from "./TipTap.vue?vue&type=template&id=7e7d0d0c&"
import script from "./TipTap.vue?vue&type=script&lang=js&"
export * from "./TipTap.vue?vue&type=script&lang=js&"
import style0 from "./TipTap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports